<template>
    <div class="dashboard">
        <h1>車両一覧</h1>
        <div class="l-mb4">
            <router-link class="button--oval--primary" :to="{ name: 'offices_vehicles_create' }">新しい車両を登録する</router-link>
        </div>
        <table>
            <tr>
                <th v-for="data in tableSet" :key="data.key" :class="data.class">
                    {{ data.head }}
                </th>
                <th class="is-right">&nbsp;</th>
            </tr>
            <tr v-for="(list, index) in listVehicles" :key="`list${index}`" :class="setClassInspectionStyle(list.inspection_date)">
                <template v-for="data in tableSet">
                    <td v-if="data.key === 'inspection_date'" :key="`list${index}${data.key}`" :class="data.class">
                        {{ list[data.key] | changeFormatInspectionDate }}
                    </td>
                    <td v-else :key="`list${index}${data.key}`" :class="data.class">
                        {{ list[data.key] }}
                    </td>
                </template>
                <td class="is-right">
                    <router-link class="button--primary" :to="{ name: 'offices_vehicles_update', params: { id: String(list.vehicle_id) }}" type="button" tag="button">編集</router-link>
                </td>
            </tr>
        </table>
        <Modal :modal="modal" @action="modalAction($event)" @close="$_modalClose()" />
    </div>
</template>

<script>
    "use strict";

    import common from "@/mixins/common";

    const tableVehicles = [
        {
            "class": "",
            "head": "車両ID",
            "key": "vehicle_id",
        },
        {
            "class": "",
            "head": "車両No",
            "key": "vehicle_number",
        },
        {
            "class": "is-left",
            "head": "車両サイズ",
            "key": "vehicle_size_name",
        },
        {
            "class": "",
            "head": "メインドライバー",
            "key": "driver_name",
        },
        {
            "class": "",
            "head": "状態",
            "key": "status",
        },
        {
            "class": "is-right",
            "head": "点検日",
            "key": "inspection_date",
        },
    ];

    export default {
        "filters": {
            changeFormatInspectionDate(val) {
                // dateの表示形式を変更
                if (typeof val === "string") {
                    return val.replace(/-/g, "/");
                } else {
                    return val;
                }
            },
        },
        "mixins": [
            common,
        ],
        data() {
            return {
                "classInspectionStyle": "",
                "date": {
                    "today": "",
                    "oneMonthLater": "",
                    "twoMonthsLater": "",
                },
                "listVehicles": [],
                "tableSet": tableVehicles,
            };
        },
        created() {
            this.setDate();
            this.fetchingListVehicles();
        },
        "methods": {
            setDate() {
                const today = new Date();
                const oneMonthLater = new Date();
                const twoMonthsLater = new Date();
                // 今日の日付をset
                let year = today.getFullYear();
                let month = ("0" + (today.getMonth() + 1)).slice(-2);
                let data = ("0" + today.getDate()).slice(-2);
                this.date.today = `${year + "-" + month + "-" + data}`;
                // 1か月後の日付をset
                oneMonthLater.setMonth(oneMonthLater.getMonth() + 1);
                year = oneMonthLater.getFullYear();
                month = ("0" + (oneMonthLater.getMonth() + 1)).slice(-2);
                data = ("0" + oneMonthLater.getDate()).slice(-2);
                this.date.oneMonthLater = `${year + "-" + month + "-" + data}`;
                // 2か月後の日付をset
                twoMonthsLater.setMonth(twoMonthsLater.getMonth() + 2);
                year = twoMonthsLater.getFullYear();
                month = ("0" + (twoMonthsLater.getMonth() + 1)).slice(-2);
                data = ("0" + twoMonthsLater.getDate()).slice(-2);
                this.date.twoMonthsLater = `${year + "-" + month + "-" + data}`;
            },
            setClassInspectionStyle(date) {
                // 点検日別classをset
                if (date) {
                    if (date <= this.date.oneMonthLater) {
                        return "cust-one-month";
                    } else if (date <= this.date.twoMonthsLater) {
                        return "cust-two-month";
                    }
                }
            },
            fetchingListVehicles() {
                // 全車両データ取得
                common.$_axios.get(
                    `${common.$_configs.apiUrl}/vehicles`,
                    this.$_requestConfig()
                ).then(response => {
                    // 車両IDで昇順
                    this.listVehicles = response.data.sort((a, b) => a.vehicle_id - b.vehicle_id);
                }).catch(() => {
                    this.$_modalError("fetchingVehiclesError");
                });
            },
        },
    };
</script>
